import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import CryptoJS from 'crypto-js';

import { history } from 'containers/App';

import QuestionnaireType from 'common/questionnaires/QuestionnaireType';
import FormGroupTypes from 'common/questionnaires/FormGroupTypes';
import SelectAccountModal from 'components/Modals/SelectAccountModal';
import QuestionBlock from 'components/Questionnaires/QuestionBlock';

import {
  newPreQualQuestionnaire
} from 'actions';

const PreQualifyingQuestionnaire = ({ usePreQualifyingQuestionnaire, customerName, customerDetails, selectedAccountId, questionnaire, rcEnabled }) => {
  const dispatch = useDispatch();
  const messageValues = useMemo(() => ({ CustomerName: customerName, DerivedName: customerName }), [customerName]);

  if (usePreQualifyingQuestionnaire === false) {
    history.push('/form-selection');
  }

  const showBlock = (b) => {
    if (b) {
      if (Object.prototype.hasOwnProperty.call(b, 'visible')) {
        if (typeof b.visible === 'boolean') {
          return b.visible;
        }
        if (typeof b.visible === 'function') {
          return b.visible(questionnaire?.answers, questionnaire?.answers);
        }
      }
    }
    return false;
  };

  const showResult = (r) => {
    if (r) {
      if (Object.prototype.hasOwnProperty.call(r, 'condition')) {
        if (typeof r.condition === 'boolean') {
          return r.condition;
        }
        if (typeof r.condition === 'function') {
          return r.condition(questionnaire?.answers);
        }
      }
    }
    return false;
  };

  const getFormGroupForms = formGroup => FormGroupTypes.find(f => f.key === formGroup);

  useEffect(() => {
    dispatch(newPreQualQuestionnaire(rcEnabled, customerDetails));
  }, []);

  return (
    <React.Fragment>
      { selectedAccountId === 0 && <SelectAccountModal /> }
      { selectedAccountId > 0 && <div className="questionnaire pre-qualifying-questionnaire">
        { questionnaire && questionnaire.blocks && questionnaire.blocks.map(b => b && showBlock(b) && <QuestionBlock questionnaireType={ QuestionnaireType.PreQualifying } key={ b.id } block={ b } messageValues={ messageValues } />) }
        { questionnaire && questionnaire.results && questionnaire.results.map(r => r && showResult(r)
          && React.createElement(r.component, { ...r.componentProps, key: r.id, id: r.id, info: r.info, formType: r.formType, formGroup: r.formGroup && getFormGroupForms(r.formGroup), title: r.title, accountId: selectedAccountId, messageValues })) }
      </div>}

    </React.Fragment>
  );
};

PreQualifyingQuestionnaire.propTypes = {
  usePreQualifyingQuestionnaire: PropTypes.bool,
  customerName: PropTypes.string,
  customerDetails: PropTypes.shape(),
  selectedAccountId: PropTypes.number,
  questionnaire: PropTypes.shape(),
  rcEnabled: PropTypes.bool,
};

PreQualifyingQuestionnaire.defaultProps = {
  usePreQualifyingQuestionnaire: true,
  customerName: '',
  customerDetails: null,
  selectedAccountId: 0,
  questionnaire: null,
  rcEnabled: false
};

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig,
      customerData,
      key
    },
    questionnaires: { preQualQuestionnaire },
    form: { selectedAccountId }
  } = state;

  const decryptedArray = CryptoJS.AES.decrypt(customerData, key);
  const decryptedText = decryptedArray.toString(CryptoJS.enc.Utf8);
  const customerDetails = JSON.parse(decryptedText);

  return {
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire,
    customerName: customerDetails && customerDetails.CustomerName,
    customerDetails,
    selectedAccountId,
    questionnaire: preQualQuestionnaire,
    rcEnabled: onlineConfig?.formTypes?.some(obj => obj.formType?.startsWith('rc') && obj.isEnabled === true)
  };
}

export default connect(
  mapStateToProps,
)(PreQualifyingQuestionnaire);
